/*
 * Lemonade Training Oy, copy rights, all right reserved.
 * config/features.movementStateRead as one value; unknown or unreadable is off.
 */
import { isMovementStateReadLive } from "@lemonadetraining/contracts";
import { useFeatureFlags } from "./useFeatureFlags";

export type FlagMode = "loading" | "on" | "off";

export function useMovementStateReadFlag(enabled: boolean): FlagMode {
  const { flags, isLoading } = useFeatureFlags(enabled);
  if (isLoading) return "loading";
  return isMovementStateReadLive(flags) ? "on" : "off";
}
